import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Teleport as _Teleport } from "vue"

import { ref, onMounted } from 'vue';
  import dayjs from 'dayjs';
  import isBetween from 'dayjs/plugin/isBetween';
  import { isMobile } from '@/utils';
  import Notice1 from './notice-1/index.vue';
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  dayjs.extend(isBetween);

  const dialogs = [
    {
      key: '8/24 ~ 9/06',
      component: Notice1,
      startTime: '2023-08-24T00:00:00+09:00',
      endTime: '2023-09-06T23:59:59+09:00',
    }
  ];

  const currentDialog = dialogs.find(item => dayjs().isBetween(dayjs(item.startTime), dayjs(item.endTime), undefined, '[]'));

  const POPUP_NOTICE_VISIBLE_TIME = `cocacola-s4-popup-notice-${currentDialog?.key}`;
  const popupVisible = ref(false);

  const isMobileDevice = isMobile();

  onMounted(() => {
    if (currentDialog) {
      const popupVisibleTime = window.localStorage.getItem(POPUP_NOTICE_VISIBLE_TIME);
      if (popupVisibleTime) {
        popupVisible.value = dayjs().isAfter(popupVisibleTime);
      } else {
        popupVisible.value = true;
      }
    }
  });

  function close(type: 'common' | 'day') {
    popupVisible.value = false;
    // 点了今日不要再打开
    if (type === 'day') {
      // 记录下一次打开弹窗的时间
      window.localStorage.setItem(POPUP_NOTICE_VISIBLE_TIME, dayjs().startOf('day').add(1, 'day').toISOString());
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_AppOffcanvas = _resolveComponent("AppOffcanvas")!
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(isMobileDevice))
      ? (_openBlock(), _createBlock(_component_AppOffcanvas, {
          key: 0,
          "model-value": popupVisible.value,
          class: "popup-offcanvas",
          placement: "offcanvas-bottom"
        }, {
          default: _withCtx(() => [
            (_unref(currentDialog)?.component)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentDialog)?.component), {
                  key: 0,
                  onClose: close
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model-value"]))
      : (_openBlock(), _createBlock(_component_AppDialog, {
          key: 1,
          visible: popupVisible.value,
          btns: [],
          class: "popup-notice"
        }, {
          default: _withCtx(() => [
            (_unref(currentDialog)?.component)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentDialog)?.component), {
                  key: 0,
                  onClose: close
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["visible"]))
  ]))
}
}

})